import { createSelector } from '@ngrx/store';
import { prospectsAdapter, prospectsFeature } from './prospect.reducer';

const { selectAll, selectEntities } = prospectsAdapter.getSelectors();

export const {
  selectProspectsState,
  selectLoading: selectProspectsLoading,
  selectError: selectProspectsError,
  selectTotal: selectProspectsTotal,
  selectGrandTotal: selectProspectsGrandTotal,
  selectPage: selectProspectsPage,
  selectLimit: selectProspectsLimit,
  selectFilters: selectProspectsFilters,
} = prospectsFeature;

export const selectAllProspects = createSelector(prospectsFeature.selectProspectsState, selectAll);
export const selectProspectEntities = createSelector(prospectsFeature.selectProspectsState, selectEntities);
